import {
  BinarySensorTypeInternal,
  ChannelTypeInternal,
  GateKindInternal,
  SensorTypeInternal,
} from '../../../../../../data-access/gql-types/graphql';
import { AvailableIcon } from '../../../../../../types';
import { brightnessIcons } from './icons/brightness';
import { coverIcons } from './icons/cover';
import { floodIcons } from './icons/flood';
import { gateIcons } from './icons/gate';
import { humidityIcons } from './icons/humidity';
import { inputIcons } from './icons/input';
import { lightIcons } from './icons/light';
import { meterIcons } from './icons/meter';
import { movementIcons } from './icons/movement';
import { optimizerIcons } from './icons/optimizer';
import { pressureIcons } from './icons/pressure';
import { reedIcons } from './icons/reed';
import { switchIcons } from './icons/switch';
import { temperatureIcons } from './icons/temperature';
import { windIcons } from './icons/wind';

type AdditionalParams = {
  gateKind?: GateKindInternal;
  sensorType?: SensorTypeInternal;
  binarySensorType?: BinarySensorTypeInternal;
};

export const availableIcons = (channelType: ChannelTypeInternal, params?: AdditionalParams): AvailableIcon[] => {
  switch (channelType) {
    case ChannelTypeInternal.Blind:
      return coverIcons();
    case ChannelTypeInternal.Switch:
      return switchIcons();
    case ChannelTypeInternal.Meter:
      return meterIcons();
    case ChannelTypeInternal.Optimizer:
      return optimizerIcons();
    case ChannelTypeInternal.Light:
      return lightIcons();
    case ChannelTypeInternal.Gate:
      return gateIcons(params?.gateKind as GateKindInternal);
    case ChannelTypeInternal.Sensor:
      switch (params?.sensorType) {
        case SensorTypeInternal.Brightness:
          return brightnessIcons();
        case SensorTypeInternal.Humidity:
          return humidityIcons();
        case SensorTypeInternal.Pressure:
          return pressureIcons();
        case SensorTypeInternal.Temperature:
          return temperatureIcons();
        case SensorTypeInternal.Wind:
          return windIcons();
        default:
          return [];
      }
    case ChannelTypeInternal.BinarySensor:
      switch (params?.binarySensorType) {
        case BinarySensorTypeInternal.Flood:
          return floodIcons();
        case BinarySensorTypeInternal.Movement:
          return movementIcons();
        case BinarySensorTypeInternal.ReedSwitch:
          return reedIcons();
        case BinarySensorTypeInternal.Input:
          return inputIcons();
        default:
          return [];
      }

    default:
      return [];
  }
};
